import StyleSheet from "react-native-media-query";
import {
  appBarColor,
  primaryColor,
  subTextColor,
  whiteColor,
} from "../../constant/constantCss";
import { Dimensions } from "react-native";
export const { ids, styles } = StyleSheet.create({
  imageContainer: {
    height: Dimensions.get("window").height,
  },
  imageBackground: {
    position: "relative",
    height: Dimensions.get("window").height,
    width: "100%",
  },
  container: {
    padding: 50,
    position: "absolute",
    top: 60,
    left: "40%",
    right: "40%",
    bottom: 50,
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 576px)": {
      left: "0%",
      right: "0%",
    },
  },
  navBarContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 60,
    paddingHorizontal: 40,
    backgroundColor: appBarColor,
    "@media (max-width: 768px)": {
      height: 60,
      paddingHorizontal: 20,
    },
  },
  flexRow: {
    height: "100%",
    flexDirection: "row",
    gap: 20,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  centeredContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    resizeMode: "contain",
    width: 300,
    height: 150,
    "@media (max-width: 480px)": {
      width: 220,
      height: 110,
    },
  },
  button: {
    backgroundColor: primaryColor,
    color: whiteColor,
    borderWidth: 0,
    minWidth: 350,
    "@media (max-width: 480px)": {
      minWidth: "100%",
    },
  },
});
